module.exports = __webpack_public_path__ + "static/media/TrendsTeaser.7d10ebf9.png";